"use strict";
var focusHelper = require("../components/focus");
var slickCarousel = require("../global/slickCarousel");
var debounce = require("lodash/debounce");
var outFocusMenu = require("../global/outFocusMenu");
var lazyLoading = require("../global/lazyLoading");
var isBisEnabled = $(".attributes").data("isbisenabled");
var googleRecaptcha = require("../googleRecaptcha");

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;
    var $productSet = $(".product-set").length;

    if ($("#quickViewModal").hasClass("show") && !$productSet) {
        pid = $($el)
            .closest(".modal-content")
            .find(".product-quickview")
            .data("pid");
    } else if ($(".product-set-detail").length || $productSet) {
        pid = $($el)
            .closest(".product-detail")
            .find(".product-id").first().text();
    } else {
        pid = $(".product-detail:not(\".bundle-item\")").data("pid");
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el, isCart) {
    if (isCart || $el.hasClass("product-tile")) {
        return $($el).find("select.quantity-select");
    } else {
        return $el && $(".set-items").length
            ? $($el)
                .closest(".product-detail")
                .find("select.quantity-select")
            : $("select.quantity-select");
    }
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find("[data-attr=\"" + attr.id + "\"] [data-attr-value=\"" + attrValue.value + "\"]");
        var $swatchButton = $attrValue.parent();
        var $selectedColorContainer = $(".m-product-detail__attribute-color").find(".m-product-detail__attribute-selected-value");
        var displayValue = $attrValue.data("attr-display-value");

        if (attrValue.selected) {
            $attrValue.addClass("selected");
            $swatchButton.addClass("selected");
            $attrValue.siblings(".selected-assistive-text").text(msgs.assistiveSelectedText);
            if ($swatchButton.closest(".m-product-detail__attribute-color").length) {
                $selectedColorContainer.empty().html(displayValue);
                if ($selectedColorContainer.hasClass("m-product-detail__attribute-disabled")) {
                    $selectedColorContainer.removeClass("m-product-detail__attribute-disabled");
                }
            }
        } else {
            $attrValue.removeClass("selected");
            $swatchButton.removeClass("selected");
            $attrValue.siblings(".selected-assistive-text").empty();
        }

        if (attrValue.url) {
            $swatchButton.attr("data-url", attrValue.url);
        } else {
            $swatchButton.removeAttr("data-url");
        }

        // Disable if not selectable
        $attrValue.removeClass("selectable unselectable");
        $swatchButton.removeClass("selectable unselectable");

        if (!isBisEnabled) {
            $attrValue.addClass(attrValue.selectable ? "selectable" : "unselectable");
            $swatchButton.addClass(attrValue.selectable ? "selectable" : "unselectable");
        }
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = "[data-attr=\"" + attr.id + "\"]";
    var $defaultOption = $productContainer.find($attr + " .select-" + attr.id + " option:first");
    $defaultOption.attr("value", attr.resetUrl);

    handleVariationsDropdown(attr, $attr, $productContainer);
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = [];
    var colorAttribute;
    var sizeAttribute;
    var gripAttribute = $(".attributes").data("gripattribute");

    if ($productContainer === $("#config-tensions")) {
        colorAttribute = $productContainer.data("colorattribute");
    } else {
        colorAttribute = $(".attributes").data("colorattribute");
    }

    if (colorAttribute && colorAttribute !== "") {
        attrsWithSwatches.push(colorAttribute);
    }

    if ($productContainer === $("#config-tensions")) {
        sizeAttribute = $productContainer.data("sizeattribute");
    } else {
        sizeAttribute = $(".attributes").data("sizeattribute");
    }

    if (sizeAttribute && sizeAttribute !== "") {
        attrsWithSwatches.push(sizeAttribute);
    }

    if (gripAttribute && gripAttribute !== "") {
        attrsWithSwatches.push(gripAttribute);
    }

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer, isCart) {
    var availabilityValue = "";
    var availabilityMessages = response.product.availability.messages;
    if (response.product.readyToOrder) {
        availabilityMessages.forEach(function (message) {
            availabilityValue += "<li><div>" + message + "</div></li>";
        });
    }

    if ($productContainer.hasClass("set-item") && $productContainer.hasClass("product-tile")) {
        $("body").trigger("setItem:updateAvailability", {
            product: response.product,
            $productContainer: $productContainer,
            message: availabilityValue,
            resources: response.resources
        });
    } else {
        $($productContainer).trigger("product:updateAvailability", {
            product: response.product,
            $productContainer: $productContainer,
            message: availabilityValue,
            resources: response.resources,
            isCart: isCart
        });
    }
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer
        .find(".product-options")
        .empty()
        .html(optionsHtml);
}

function zoomProductImages() {
    var $zoomContainer = $("body").find(".m-product-detail__primary-image-wrapper");

    if ($zoomContainer.length) {
        if (window.mqRespond.status.lgUp) {
            $zoomContainer.each(function () {
                $(this).zoom({
                    touch: false,
                    callback: addAltZoomImage,
                    onZoomIn: function() {
                        $zoomContainer.find(".hide-on-zoom").toggleClass("d-none", true);
                    },
                    onZoomOut: function() {
                        $zoomContainer.find(".hide-on-zoom").toggleClass("d-none", false);
                    }
                });
            });
        } else {
            $zoomContainer.trigger("zoom.destroy");
            $("body").find(".zoomImg").remove();
        }
    }
}

/**
* Handles the UI updates for a product variant set item based on the server response.
*
* Updates product container data attributes (orderable, pid, ready-to-order), swatch values,
* product image, pricing, and availability. Also triggers the "product:updateAddToCart" event
* for the add-to-cart button within the product container.
*
* @param {Object} response - The server response containing product data, variation attributes, images, price, and resources.
* @param {JQuery} $productContainer - The jQuery object representing the product container to update.
* @returns {void}
*/
function handleVariantResponseSetItem(response, $productContainer) {
    if (!response.product) {
        return;
    }

    // handle orderable
    $productContainer.data("orderable", response.product.orderable);
    $productContainer.data("pid", response.product.id);
    $productContainer.data("ready-to-order", response.product.readyToOrder);

    // update swatch values
    if (response.product && response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
    }

    // handle images
    var image = response.product.images["medium"][0];
    var $tileImage = $productContainer.find(".c-product-tile--bundle-item__tile-image");

    $tileImage.html(`<img class="tile-image lazyload" data-srcset="${image.url}"></img>`);

    lazyLoading.refreshLazyLoadingFeature(".tile-image");

    // Update pricing
    $(".prices", $productContainer).html(response.product.price.html);

    // Update availability
    updateAvailability(response, $productContainer);
    $productContainer.find("button.add-to-cart")
            .trigger("product:updateAddToCart", {
                product: response.product,
                $productContainer: $productContainer,
                isSetItem: true
            });
}
/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer, isCart) {
    var isChoiceOfBonusProducts = $productContainer.parents(".choose-bonus-product-dialog").length > 0;
    var isVaraint;

    if (response.product && response.product.variationAttributes) {
        $productContainer.data("orderable", response.product.orderable);
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === "variant";

        if (isChoiceOfBonusProducts && isVaraint) {
            var $productBonus = $productContainer.parent(".bonus-product-item");

            $productBonus.data("pid", response.product.id);
            $productBonus.data("ready-to-order", response.product.readyToOrder);
        }
    }

    // Update primary images
    if (response.product) {
        var primaryImageUrls = response.product.images;
        var $mainCarouselWrapper = $(".m-product-detail__main-carousel");
        var $thumbsCarouselWrapper = $(".m-product-detail__thumb-images");
        var $primaryImagesSlider = $(".m-product-detail__main-carousel .slick-slider");
        var $thumbImagesSlider = $(".m-product-detail__thumb-images .slick-slider");
        var endLoop = primaryImageUrls["large"].length;
        var smallImagesLength = primaryImageUrls["small"].length;
        var $productLabel = $(".m-product-detail__label");
        var $autoHeightClass = "m-product-detail__thumb-images-auto-height";
        var $freeDeliveryMention = $(".free-delivery-mention");
        let $brandImageClone = $productContainer.find(".m-product-detail__brand-image").length ? $productContainer.find(".m-product-detail__brand-image").first().clone() : $();

        $primaryImagesSlider.slick("unslick");
        $primaryImagesSlider.empty();

        $thumbImagesSlider.slick("unslick");
        $thumbImagesSlider.empty();

        if (window.mqRespond.status.lgUp) {
            $(".m-product-detail__primary-image-wrapper").trigger("zoom.destroy");
            $primaryImagesSlider.find(".zoomImg").remove();
        }

        for (var big = 0; big < endLoop; big++) {
            var imageUrl = primaryImageUrls["large"][big];
            $("<div class=\"c-ratio-container c-ratio-container--secondary m-product-detail__primary-image-wrapper\"><img srcset=\"" + imageUrl.url + "\" data-original=\"" + imageUrl.zoomurl + "\" class=\"js-open-zoom-popin m-product-detail__primary-image\" alt=\"" + imageUrl.alt + "\" itemprop=\"image\" sizes=\"" + imageUrl.sizes + "\" src=\"" + imageUrl.zoomurl + "\"></div>").appendTo($primaryImagesSlider);
        }

        for (var small = 0; small < endLoop; small++) {
            var imageSUrl = primaryImageUrls["small"][small];
            $("<div class=\"m-product-detail__thumb-image-wrapper\"><img data-srcset=\"" + imageSUrl.url + "\" class=\"m-product-detail__thumb-image lazyload\" alt=\"" + imageSUrl.alt + "\" sizes=\"" + imageSUrl.sizes + "\" loading=\"lazy\"></div>").appendTo($thumbImagesSlider);
        }

        if (!isCart) {
            $(".m-product-detail__primary-image-wrapper").append($brandImageClone);
            lazyLoading.refreshLazyLoadingFeature();
        }

        if (response.product.stickerConfiguration) {
            var stickerConfigurationLabel = response.product.stickerConfiguration.label;
            var sticketConfigurationColor = response.product.stickerConfiguration.color;
            var stickerTag = "<span class=\"m-product-detail__label c-product-tile__label\" style=\"background-color: " + sticketConfigurationColor + "\" + >" + stickerConfigurationLabel + "</span>";

            if ($productLabel.length) {
                if (stickerConfigurationLabel && sticketConfigurationColor) {
                    $productLabel.replaceWith(stickerTag);
                } else {
                    $productLabel.addClass("d-none");
                }
            } else {
                if (stickerConfigurationLabel && sticketConfigurationColor) {
                    $(stickerTag).appendTo($mainCarouselWrapper);
                }
            }
        } else {
            if ($productLabel.length) {
                $productLabel.addClass("d-none");
            }
        }

        // Update free delivery mention
        if (response.product.orderable) {
            if ($freeDeliveryMention.length && $freeDeliveryMention.hasClass("d-none")) {
                $freeDeliveryMention.removeClass("d-none");
            }
        } else {
            if ($freeDeliveryMention.length) {
                $freeDeliveryMention.addClass("d-none");
            }
        }

        $(".m-product-detail__sticky-image").attr("srcset", primaryImageUrls["small"][0].url)
            .attr("data-srcset", primaryImageUrls["small"][0].url);

        $thumbImagesSlider.css("opacity", "0");

        slickCarousel.initSlickSlider($primaryImagesSlider);
        slickCarousel.initSlickSlider($thumbImagesSlider);

        setTimeout(function () {
            $thumbImagesSlider.slick("refresh");

            if (smallImagesLength > 5) {
                if ($thumbsCarouselWrapper.hasClass($autoHeightClass)) {
                    $thumbsCarouselWrapper.removeClass($autoHeightClass);
                }
            } else {
                if (!$thumbsCarouselWrapper.hasClass($autoHeightClass)) {
                    $thumbsCarouselWrapper.addClass($autoHeightClass);
                }
            }

            $thumbImagesSlider.css("opacity", "1");
        }, 500);

        if (window.mqRespond.status.lgUp) {
            setTimeout(function () {
                let $zoomContainer = $("body").find(".m-product-detail__primary-image-wrapper");

                $zoomContainer.each(function () {
                    $(this).zoom({
                        touch: false,
                        onZoomIn: function() {
                            $zoomContainer.find(".hide-on-zoom").toggleClass("d-none", true);
                        },
                        onZoomOut: function() {
                            $zoomContainer.find(".hide-on-zoom").toggleClass("d-none", false);
                        }
                    });
                });
            }, 500);
        } else {
            $(".m-product-detail__primary-image-wrapper").trigger("zoom.destroy");
            $("body").trigger("zoomPopin:init", {images: primaryImageUrls["small"], variationAttributes: response.product.variationAttributes});
        }
    }

    // Update pricing
    if (!isChoiceOfBonusProducts && response.product) {
        let priceSelector;
        // Retrieve variable from SitePreferences in isml to check current site
        priceSelector = $(".prices:not(.string-product-prices)", $productContainer).length ? $(".prices:not(.string-product-prices)", $productContainer) : $(".prices");
        priceSelector.empty().html(response.product.price.html);
    }

    // Update promotions
    if (response.product) {
        $productContainer
            .find(".promotions")
            .empty()
            .html(response.product.promotionsHtml);

        updateAvailability(response, $productContainer, isCart);

        if (isChoiceOfBonusProducts) {
            var $selectButton = $productContainer.find(".select-bonus-product");
            $selectButton.trigger("bonusproduct:updateSelectButton", {
                product: response.product,
                $productContainer: $productContainer
            });
        } else {
            // Enable "Add to Cart" button if all required attributes have been selected
            if (isCart) {
                $productContainer.find("button.add-to-cart-from-cart")
                    .trigger("product:updateAddToCart", {
                        product: response.product,
                        $productContainer: $productContainer,
                        isCart: isCart
                    })
                    .trigger("product:statusUpdate", response.product);
            } else {
                $("button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global")
                    .trigger("product:updateAddToCart", {
                        product: response.product,
                        $productContainer: $productContainer,
                        isUserInBlockedGroupPlayTest: response.isUserInBlockedGroupPlayTest
                    })
                    .trigger("product:statusUpdate", response.product);
            }

            if (response.product && response.product.isBabolatCup) {
                $(".js-babolat-cup-init-btn").trigger("product:updateBabolatCup", {
                    response: response
                });
            }
        }
    }
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {object} product
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(product, $productContainer, isCart) {
    var quantities = product.quantities;
    var isVariant = product.productType == "variant";

    if ($productContainer.parent(".bonus-product-item").length <= 0) {
        var optionsHtml = quantities
            .map(function (quantity) {
                var selected = quantity.selected ? " selected " : "";
                var disabled = isVariant ? "" : "disabled";

                return "<option value=\"" + quantity.value + "\"  data-url=\"" + quantity.url + "\"" + selected + " " + disabled + ">" + quantity.value + "</option>";
            })
            .join("");
        getQuantitySelector($productContainer, isCart)
            .empty()
            .html(optionsHtml);
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrlDefault, $productContainer) {
    var selectedValueUrl = selectedValueUrlDefault;

    if (selectedValueUrl) {
        $("body").trigger("product:beforeAttributeSelect", { url: selectedValueUrl, container: $productContainer });
        var isCart = $(".js-isCart").data("iscart");
        var isSetItem = $productContainer.hasClass("bundled-set-item");

        if ($productContainer.hasClass("c-product-push")) {
            selectedValueUrl += "&isExpliciteRecommendation=true";
        }

        $.spinner().start();
        $.ajax({
            url: selectedValueUrl,
            method: "GET",
            success: function (data) {
                if (isSetItem) {
                    handleVariantResponseSetItem(data, $productContainer);
                    updateQuantities(data.product, $productContainer);
                    $("body").trigger("product:afterAttributeSelect", { data: data, container: $productContainer });
                    $.spinner().stop();
                    return;
                }

                handleVariantResponse(data, $productContainer, isCart);

                if (data.product) {
                    if (data.product.quantities.length === 0 || !data.product.orderable || !data.product.available || data.product.isPlayTest) {
                        $productContainer.find(".quantity-select").parent().hide();
                    } else {
                        $productContainer.find(".quantity-select").parent().show();
                        $productContainer.find(".quantity-select").parent().removeClass("d-none");
                    }

                    updateOptions(data.product.optionsHtml, $productContainer);
                    updateQuantities(data.product, $productContainer, isCart, isSetItem);
                }

                if (isCart) {
                    $("body").trigger("cart:afterAttributeSelect", { data: data, container: $productContainer });

                    if (!$productContainer.hasClass("size-selected")) {
                        $("body").trigger("cart:size-select", { container: $productContainer });
                    }
                } else {
                    $("body").trigger("product:afterAttributeSelect", { data: data, container: $productContainer });
                }

                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    } else if (isSetItem) {
        var $addToCartBtn = $(".add-to-cart", $productContainer);
        var sizeSelector = $(".size-select", $productContainer);
        var sizeSelectorText = sizeSelector.data("select-size-text");
        $addToCartBtn.attr("disabled", "true");
        $addToCartBtn.text(sizeSelectorText);
    }
}

/**
 * @function
 * @description updates the product view when a string product attribute is selected
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function stringAttributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $("body").trigger("product:beforeAttributeSelect", { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: "GET",
            success: function (data) {
                handleStringVariantResponse(data, $productContainer);
                $("body").trigger("product:afterAttributeSelect", { data: data, container: $productContainer });
                lazyLoading.refreshLazyLoadingFeature(".js-stringing-image img");

                setTimeout(function () {
                    $.spinner().stop();
                }, 1000);
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * @function
 * @description Parses JSON from Ajax call made whenever an attribute value is selected
 * @param {Object} response - response from Ajax call
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleStringVariantResponse(response, $productContainer) {
    if (response.product && response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
    }

    if (response.product) {
        var $priceSelector = $(".string-product-prices", $productContainer);
        var stringImage = response.product.images.large[0];
        var $primaryStringImage = $productContainer.find(".js-stringing-image");

        $priceSelector.empty().html(response.product.price.html);

        $primaryStringImage.empty();
        $("<img class=\"tile-image lazyload\" loading=\"lazy\" data-srcset=\"" + stringImage.url + "\" alt=\"" + stringImage.alt + "\">").appendTo($primaryStringImage);
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $(".add-to-cart-url").val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $("<div>").append($.parseHTML(html));

    var body = $html.find(".choice-of-bonus-product");
    var footer = $html.find(".modal-footer").children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $(".modal-body")
        .spinner()
        .start();

    var $bonusProductModal = $("#chooseBonusProductModal");

    if ($bonusProductModal.length !== 0) {
        $bonusProductModal.remove();
    }

    var bonusUrl;

    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString =
        "<!-- Modal -->" +
        "<div class=\"modal fade\" id=\"chooseBonusProductModal\" tabindex=\"-1\" role=\"dialog\">" +
        "<span class=\"enter-message sr-only\" ></span>" +
        "<div class=\"modal-dialog choose-bonus-product-dialog\" " +
        "data-total-qty=\"" +
        data.maxBonusItems +
        "\"" +
        "data-UUID=\"" +
        data.uuid +
        "\"" +
        "data-pliUUID=\"" +
        data.pliUUID +
        "\"" +
        "data-addToCartUrl=\"" +
        data.addToCartUrl +
        "\"" +
        "data-pageStart=\"0\"" +
        "data-pageSize=\"" +
        data.pageSize +
        "\"" +
        "data-moreURL=\"" +
        data.showProductsUrlRuleBased +
        "\"" +
        "data-bonusChoiceRuleBased=\"" +
        data.bonusChoiceRuleBased +
        "\">" +
        "<!-- Modal content-->" +
        "<div class=\"modal-content\">" +
        "<div class=\"modal-header\">" +
        "    <span class=\"\">" +
        data.labels.selectprods +
        "</span>" +
        "    <button type=\"button\" class=\"close pull-right\" data-dismiss=\"modal\">" +
        "        <span aria-hidden=\"true\">&times;</span>" +
        "        <span class=\"sr-only\"> </span>" +
        "    </button>" +
        "</div>" +
        "<div class=\"modal-body\"></div>" +
        "<div class=\"modal-footer\"></div>" +
        "</div>" +
        "</div>" +
        "</div>";
    $("body").append(htmlString);
    $(".modal-body")
        .spinner()
        .start();

    $.ajax({
        url: bonusUrl,
        method: "GET",
        dataType: "json",
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            var $modalBody = $("#chooseBonusProductModal .modal-body");

            $modalBody.empty();
            $("#chooseBonusProductModal .enter-message").text(response.enterDialogMessage);
            $("#chooseBonusProductModal .modal-header .close .sr-only").text(response.closeButtonText);
            $modalBody.html(parsedHtml.body);
            $("#chooseBonusProductModal .modal-footer").html(parsedHtml.footer);
            $("#chooseBonusProductModal").modal("show");
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response, $productContainer) {
    $(".minicart").trigger("count:update", response);
    var messageType = response.error ? "alert-danger" : "alert-success";
    var messageSuffix = (messageType == "alert-danger") ? "error" : "success";
    var $addToCartBtn = $(".add-to-cart", $productContainer);
    var $globalAddToCart = $(".add-to-cart-global", $productContainer);
    var $activeButton = $(".m-product-detail__cta .active", $productContainer);
    let $overlay = $(".l-overlay");
    var $header = $(".l-header");
    let $minicart = $(".minicart");
    let $minicartSlider = $(".slider-minicart");
    let $minicartSlickElement = $minicartSlider.find(".slick-slider");
    let $stringingButton = $(".btn-stringing");

    // show add to cart toast
    if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if (messageSuffix === "error") {
            if ($(".add-to-cart-messages").length === 0) {
                $("body").append("<div class=\"add-to-cart-messages\"></div>");
            }

            $(".add-to-cart-messages").append("<div class=\"alert " + messageType + " add-to-basket-alert c-form-state c-form-state--" + messageSuffix + "\" role=\"alert\">" + response.message + "</div>");
        }

        $addToCartBtn.addClass("d-none");
        $globalAddToCart.addClass("d-none");
        $activeButton.removeClass("d-none");

        if (messageSuffix === "success") {
            $minicart.addClass("minicart-locked");

            setTimeout(function () {
                $overlay.removeClass("d-none").addClass("l-overlay__active-cart");
                $("body").addClass("no-scroll");
                $minicart.trigger("triggerMiniCart");
                $header.addClass("l-header__active-cart");
                $(".number-of-items").empty().append(response.cart.resources.numberOfItems);

                if (!window.mqRespond.status.lgDown && $minicartSlider.length && $minicartSlickElement.hasClass("slick-initialized") && !$minicartSlickElement.hasClass("slick-refreshed")) {
                    $minicartSlickElement.slick("refresh").addClass("slick-refreshed");
                }
            }, 500);
        }

        setTimeout(function () {
            $(".add-to-basket-alert").remove();
            $activeButton.addClass("d-none");
            $addToCartBtn.removeClass("d-none");
            $globalAddToCart.removeClass("d-none");

            if ($stringingButton.length) {
                $stringingButton.parent().removeClass("d-none");
            }
        }, 3000);
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $(".bundle-item").each(function () {
        var $this = $(this);

        childProducts.push({
            pid: $this
                .data("pid"),
            quantity: parseInt(
                $this.find(".quantity select").val(),
                10
            )
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find(".product-option")
        .map(function () {
            var $this = $(this);
            var $elOption = $this.find(".options-select");
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find("option[value=\"" + urlValue + "\"]").data("value-id");

            return {
                optionId: $this.data("option-id"),
                selectedValueId: selectedValueId
            };
        })
        .toArray();

    return JSON.stringify(options);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: "GET",
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

function destroyVideo() {
    var $videoComponent = $(".m-product-detail__video"),
        $videoContainer = $(".m-product-detail__video-container"),
        $videoToggler = $(".m-product-detail__video-toggler");

    if ($videoComponent.length && !$videoComponent.hasClass("d-none")) {
        $videoContainer.find("iframe").remove();
        $videoComponent.addClass("d-none");
        $videoToggler.removeClass("m-product-detail__video-toggler--active");
    }
}

function addAltZoomImage() {
    var $zoomContainer = $("body").find(".m-product-detail__primary-image-wrapper");

    if ($zoomContainer.length) {
        $zoomContainer.each(function () {
            let $originalAltValue = $(this).find(".m-product-detail__primary-image").attr("alt");
            $(this).find(".zoomImg").attr("alt", $originalAltValue);
        });
    }
}

function handleVariationsDropdown(attr, $attr, $productContainer) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find($attr + " [data-attr-value=\"" + attrValue.value + "\"]");
        var isSetItem = $productContainer.hasClass("bundled-set-item");

        if ($attrValue.length == 0) {
            return;
        }

        $attrValue.attr("value", attrValue.url).removeAttr("disabled");

        if (!attrValue.selectable) {
            if (!isSetItem && isBisEnabled && attrValue.hasStockRecord) {
                var attrValueInitial = $attrValue.html().split(" - ")[0];
                $attrValue.html(attrValueInitial);

                if ($productContainer.data("orderable")) {
                    var msg = $(".bisMsg").data("bis-msg");
                    $attrValue.append(" - " + msg);
                }

                if (!attr.id == "APPAREL_SIZE") {
                    $attrValue.attr("disabled", true);
                } else {
                    $attrValue.attr("value", attrValue.url);
                }
            } else {
                // cleanup possible old value label
                $attrValue.html($attrValue.html().split(" - ")[0]);
                $attrValue.attr("disabled", true);
            }
        } else {
            if (isSetItem && isBisEnabled) {
                var attrInitialValue = $attrValue.html().split(" - ")[0];

                $attrValue.html(attrInitialValue);
            }
        }
    });
}

function toggleStringing() {
    if ($("#find-stringing-shop").children().length !== 0) {
        $("button.btn-stringing").removeClass("active");
        $("#find-stringing-shop").addClass("d-none");
        $(".m-product-detail__stringing-carousel").empty();
        $(".m-product-detail__find-stringing-message").addClass("d-none");
        $("#config-tensions").empty();
    }
}

function toggleBIS() {
    if ($("#bis-subscription").children().length !== 0) {
        $("button.notify-me-btn").removeClass("active");
        $("#bis-subscription").empty();
        $(".bis-subscription__message").empty();
    }
}

function preselectAttrs() {
    var activeEls = $(".slick-active .c-product-slider__item, .slick-active.c-product-slider__item").toArray();

    activeEls.forEach(attr => {
        const $attr = $(attr);

        if (!$attr.hasClass("loaded")) {
            $attr.find(".color-attribute").eq(0).attr("selected", "selected").addClass("selected");
            attributeSelect($attr.find(".color-attribute[selected='selected']").attr("href"), $attr);
            $attr.addClass("loaded");
        }
    });
}

module.exports = {
    attributeSelect: attributeSelect,
    preselectAttrs: preselectAttrs,

    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        },
        handlePostCartAdd: handlePostCartAdd,
        miniCartReportingUrl: miniCartReportingUrl,
        attributeSelect: attributeSelect
    },

    focusChooseBonusProductModal: function () {
        $("body").on("shown.bs.modal", "#chooseBonusProductModal", function () {
            $("#chooseBonusProductModal")
                .siblings()
                .attr("aria-hidden", "true");
            $("#chooseBonusProductModal .close").focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $("body").on("hidden.bs.modal", "#chooseBonusProductModal", function () {
            $("#chooseBonusProductModal")
                .siblings()
                .attr("aria-hidden", "false");
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $("body").on("keydown", "#chooseBonusProductModal", function (e) {
            var focusParams = {
                event: e,
                containerSelector: "#chooseBonusProductModal",
                firstElementSelector: ".close",
                lastElementSelector: ".add-bonus-products"
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on("click", "button.swatch-link, a.slider-product-swatch-link, .product-tile.set-item a.swatch-link", function (e) {
            e.preventDefault();

            var $this = $(this);
            var $productContainer;

            if ($this.attr("disabled") || ($this.hasClass("selected") && $this.hasClass("color-attribute"))) {
                return;
            }

            if ($this.closest("#config-tensions").length > 0) {
                $productContainer = $("#config-tensions");

                stringAttributeSelect($this.attr("data-url"), $productContainer);
            } else {
                toggleStringing();
                toggleBIS();

                $productContainer = $this.closest(".set-item");

                if (!$productContainer.length) {
                    $productContainer = $this.closest(".product-detail");
                }

                attributeSelect($this.attr("data-url"), $productContainer);
            }
        });
    },

    selectAttribute: function () {
        var isCart = $(".js-isCart").data("iscart");

        if (isCart) {
            $(".c-product-slider__cart-slider").on("init", function () {
                preselectAttrs();
            });
        } else {
            if ($(".m-product-detail__size-select").length) {
                $(".m-product-detail__size-select option").eq().attr("selected", "selected");
            }
        }

        $(document).on("change", "select[class*=\"select-\"]:not(.order-history-select), .options-select", function (e) {
            e.preventDefault();

            toggleStringing();
            toggleBIS();

            var $this = $(this);
            var $productContainer = $this.closest(".set-item");

            if (!$productContainer.length) {
                $productContainer = $this.closest(".product-detail");
            }

            attributeSelect(e.currentTarget.value, $productContainer);

            let pdpSizeSelect = document.querySelector(".m-product-detail__size-select");

            if (pdpSizeSelect) {
                outFocusMenu.init(pdpSizeSelect);
            }

            let cartAttrSelect = document.querySelector(".product-quickview__attributes select");

            if (cartAttrSelect) {
                outFocusMenu.init(cartAttrSelect);
            }
        });
    },

    availability: function () {
        $(document).on("change", ".quantity-select", function (e) {
            e.preventDefault();

            var $this = $(this);
            var $productContainer = $this.closest(".set-item");

            if (!$productContainer.length) {
                $productContainer = $this
                    .closest(".modal-content")
                    .find(".product-quickview");
            }

            if ($(".bundle-items", $productContainer).length === 0) {
                attributeSelect(
                    $(e.currentTarget)
                        .find("option:selected")
                        .data("url"),
                    $productContainer
                );
            }

            let pdpQuantitySelect = document.querySelector(".quantity-select");
            outFocusMenu.init(pdpQuantitySelect);
        });
    },

    addToCart: function () {
        $(document).on("click", "button.add-to-cart, button.add-to-cart-global", function () {
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;
            var $this = $(this);

            if ($this.hasClass("play-test-stringable")) {
                $this.addClass("pt-active");
                $("body").trigger("stringing:start");

                return;
            }

            if ($this.closest(".set-item.product-tile").length) {
                return;
            }

            $("body").trigger("product:beforeAddToCart", this);

            if ($(".set-items").length && $this.hasClass("add-to-cart-global")) {
                setPids = [];

                $(".product-detail").each(function () {
                    var $el = $(this);

                    if (!$el.hasClass("product-set-detail")) {
                        setPids.push({
                            pid: $el
                                .find(".product-id")
                                .text(),
                            qty: $el
                                .find(".quantity-select")
                                .val(),
                            options: getOptions($el)
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($this);

            var $productContainer = $this.closest(".product-detail");

            if (!$productContainer.length) {
                $productContainer = $this
                    .closest(".quick-view-dialog")
                    .find(".product-detail");
            }

            addToCartUrl = getAddToCartUrl();

            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                quantity: getQuantitySelected($(this))
            };

            if (!$(".bundle-item").length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger("updateAddToCartFormData", form);

            const isLamborghiniProduct = $this.data("lamborghini-product");

            if (addToCartUrl) {
                if (isLamborghiniProduct) {
                    googleRecaptcha.getRecaptchaResponse().then(function () {
                        $.ajax({
                            url: addToCartUrl,
                            method: "POST",
                            data: form,
                            success: function (data) {
                                handlePostCartAdd(data);
                                $("body").trigger("product:afterAddToCart", data);
                                $.spinner().stop();
                                miniCartReportingUrl(data.reportingURL);
                            },
                            error: function (e) {
                                var response = JSON.parse(e.responseText);
                                if ($(".add-to-cart-messages").length === 0) {
                                    $("body").append("<div class=\"add-to-cart-messages\"></div>");
                                }
                                $(".add-to-cart-messages").append("<div class=\"alert alert-danger add-to-basket-alert c-form-state c-form-state--error\"" + " role=\"alert\">" + response.errorMessage + "</div>");
                                setTimeout(function () {
                                    $(".add-to-basket-alert").remove();
                                }, 3000);
                                $.spinner().stop();
                            }
                        });
                    })
                } else {
                    $.ajax({
                        url: addToCartUrl,
                        method: "POST",
                        data: form,
                        success: function (data) {
                            handlePostCartAdd(data);
                            $("body").trigger("product:afterAddToCart", data);
                            $.spinner().stop();
                            miniCartReportingUrl(data.reportingURL);
                        },
                        error: function (e) {
                            var response = JSON.parse(e.responseText);
                            if ($(".add-to-cart-messages").length === 0) {
                                $("body").append("<div class=\"add-to-cart-messages\"></div>");
                            }
                            $(".add-to-cart-messages").append("<div class=\"alert alert-danger add-to-basket-alert c-form-state c-form-state--error\"" + " role=\"alert\">" + response.errorMessage + "</div>");
                            setTimeout(function () {
                                $(".add-to-basket-alert").remove();
                            }, 3000);
                            $.spinner().stop();
                        }
                    });
                }
            }
        });
    },
    selectBonusProduct: function () {
        $(document).on("click", ".select-bonus-product", function () {
            var $this = $(this);
            var $choiceOfBonusProduct = $this.parents(".choice-of-bonus-product");
            var pid = $this.data("pid");
            var maxPids = $(".choose-bonus-product-dialog").data("total-qty");
            var submittedQty = parseInt($choiceOfBonusProduct.find(".bonus-quantity-select").val(), 10);
            var totalQty = 0;
            var optionID = $choiceOfBonusProduct.find(".product-option").data("option-id");
            var valueId = $choiceOfBonusProduct.find(".options-select option:selected").data("valueId");

            $.each($("#chooseBonusProductModal .selected-bonus-products .selected-pid"), function () {
                totalQty += $(this).data("qty");
            });

            totalQty += submittedQty;

            if (totalQty <= maxPids) {
                var selectedBonusProductHtml =
                    "" +
                    "<div class=\"selected-pid row\" " +
                    "data-pid=\"" +
                    pid +
                    "\"" +
                    "data-qty=\"" +
                    submittedQty +
                    "\"" +
                    "data-optionID=\"" +
                    (optionID || "") +
                    "\"" +
                    "data-option-selected-value=\"" +
                    (valueId || "") +
                    "\"" +
                    ">" +
                    "<div class=\"col-sm-11 col-9 bonus-product-name\" >" +
                    $choiceOfBonusProduct.find(".product-name").html() +
                    "</div>" +
                    "<div class=\"col-1\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></div>" +
                    "</div>";
                $("#chooseBonusProductModal .selected-bonus-products").append(selectedBonusProductHtml);
                $(".pre-cart-products").html(totalQty);
                $(".selected-bonus-products .bonus-summary").removeClass("alert-danger");
            } else {
                $(".selected-bonus-products .bonus-summary").addClass("alert-danger");
            }
        });
    },
    removeBonusProduct: function () {
        $(document).on("click", ".selected-pid", function () {
            $(this).remove();
            var $selected = $("#chooseBonusProductModal .selected-bonus-products .selected-pid");
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data("qty"), 10);
                });
            }

            $(".pre-cart-products").html(count);
            $(".selected-bonus-products .bonus-summary").removeClass("alert-danger");
        });
    },
    enableBonusProductSelection: function () {
        $("body").on("bonusproduct:updateSelectButton", function (e, response) {
            $("button.select-bonus-product", response.$productContainer).attr("disabled", !response.product.readyToOrder || !response.product.available);
            var pid = response.product.id;
            $("button.select-bonus-product", response.$productContainer).data("pid", pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on("click", ".show-more-bonus-products", function () {
            var url = $(this).data("url");
            $(".modal-content")
                .spinner()
                .start();
            $.ajax({
                url: url,
                method: "GET",
                success: function (html) {
                    var parsedHtml = parseHtml(html);
                    $(".modal-body").append(parsedHtml.body);
                    $(".show-more-bonus-products:first").remove();
                    $(".modal-content")
                        .spinner()
                        .stop();
                },
                error: function () {
                    $(".modal-content")
                        .spinner()
                        .stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on("click", ".add-bonus-products", function () {
            var $readyToOrderBonusProducts = $(".choose-bonus-product-dialog .selected-pid");
            var queryString = "?pids=";
            var url = $(".choose-bonus-product-dialog").data("addtocarturl");
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var $this = $(this);
                var qtyOption = parseInt($this.data("qty"), 10);
                var option = null;

                if (qtyOption > 0) {
                    if ($this.data("optionid") && $this.data("option-selected-value")) {
                        option = {};
                        option.optionId = $this.data("optionid");
                        option.productId = $this.data("pid");
                        option.selectedValueId = $this.data("option-selected-value");
                    }
                    pidsObject.bonusProducts.push({
                        pid: $this.data("pid"),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($(".pre-cart-products").html(), 10);
                }
            });

            var $bonusProductDialog = $(".choose-bonus-product-dialog");

            queryString += JSON.stringify(pidsObject);
            queryString = queryString + "&uuid=" + $bonusProductDialog.data("uuid");
            queryString = queryString + "&pliuuid=" + $bonusProductDialog.data("pliuuid");
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: "POST",
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $("#chooseBonusProductModal").modal("hide");
                        if ($(".add-to-cart-messages").length === 0) {
                            $("body").append("<div class=\"add-to-cart-messages\"></div>");
                        }
                        $(".add-to-cart-messages").append("<div class=\"alert alert-danger add-to-basket-alert c-form-state c-form-state--error\"" + " role=\"alert\">" + data.errorMessage + "</div>");
                        setTimeout(function () {
                            $(".add-to-basket-alert").remove();
                        }, 3000);
                    } else {
                        $(".configure-bonus-product-attributes").html(data);
                        $(".bonus-products-step2").removeClass("hidden-xl-down");
                        $("#chooseBonusProductModal").modal("hide");

                        if ($(".add-to-cart-messages").length === 0) {
                            $("body").append("<div class=\"add-to-cart-messages\"></div>");
                        }
                        $(".minicart-quantity").html(data.totalQty);
                        $(".add-to-cart-messages").append("<div class=\"alert alert-success add-to-basket-alert c-form-state c-form-state--success\"" + " role=\"alert\">" + data.msgSuccess + "</div>");
                        setTimeout(function () {
                            $(".add-to-basket-alert").remove();
                            if ($(".cart-page").length) {
                                location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    handleProductImagesZoom: function () {
        setTimeout(function () {
            zoomProductImages();
        }, 800);

        $(window).on("resize orientationchange", debounce(function () {
            if (window.mqRespond.status.lgUp) {
                zoomProductImages();
            } else {
                $(".m-product-detail__primary-image-wrapper").trigger("zoom.destroy");
            }
        }, 500));
    },

    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl,
    updateAttrs: updateAttrs
};
